import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { TeamContext, UserContext } from "../../../../context";
import { IPlayer } from "../../../../interfaces";


const SpinWheelNotification = () => {
	const { t } = useTranslation();
	const { game } = useContext(TeamContext);
	const { userData } = useContext(UserContext);

	const isTheUserSpinOwner = userData?.email === game?.gameInfo.currentSpinOwner;
	const spinWheelPlayer = game?.players.find((player: IPlayer) => { return player.email === game?.gameInfo.currentSpinOwner; });

	if (isTheUserSpinOwner) {
		return (
			<div className="wheel_notification">
				<p className="wheel_notification__subtitle center_horizontally_and_vertically animation_ripple animation_ripple_delay_2">
					{t("wowYourSolutionCardsText")} &nbsp; <span className={`text_color_${spinWheelPlayer?.color}`}> {spinWheelPlayer?.nickname} </span>
				</p>
				<p className="wheel_notification__title center_horizontally_and_vertically animation_ripple animation_ripple_delay_4">
					{t("spinTheWeelText")}
				</p>
			</div>
		);
	}

	return (
		<div className="wheel_notification">
			<p className="wheel_notification__subtitle center_horizontally_and_vertically animation_ripple animation_ripple_delay_2">
				<span className={`text_color_${spinWheelPlayer?.color}`}> {spinWheelPlayer?.nickname} </span> {t("solutionCardHasBeenChoosenText")}
			</p>
			<p className="wheel_notification__title center_horizontally_and_vertically animation_ripple animation_ripple_delay_4">
				{t("waitForText")} <span className={`span_margin text_color_${spinWheelPlayer?.color}`}> {spinWheelPlayer?.nickname} </span> <span></span> {t("toSpinTheWeelText")}
			</p>
		</div>
	);
};

export default SpinWheelNotification;
